// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5ebd9291","732":"f92e6420","977":"ed0b7922"}[chunkId] + ".chunk.js";
};